export enum validateStatus {
  OK = 'ok',
  IN_USE = 'in-use',
}
